import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";

import Presentations from "../presentations/Presentations";
import Documents from "../documents/Documents";
import News from "../news/News";
import Webforms from "../webform/Webforms";
import Events from "../events/Events";
import { getTemplateByIdentity } from "../../../utils/helpers";

import { useEmailDataContext } from "../../../partials/dataContext";
import { Select, MenuItem, FormControl, InputLabel, styled } from "@mui/material";

export default function Content() {
  const { setContentTypeSelected, selectedTemplate } = useEmailDataContext();

  const [options, setOptions] = useState([]);
  const [activeTab, setActiveTab] = useState("0");

  // redux
  const config = useSelector((state) => state.configReducer);
  const templateData = getTemplateByIdentity(selectedTemplate, config.templates);

  const CustomMenuItem = styled(MenuItem)(() => ({
    fontSize: "14px",
    lineHeight: "1",
    minHeight: "15px",
  }));

  useEffect(() => {
    if (templateData && templateData.contentTypes) {
      let items = [];
      templateData.contentTypes.forEach((type) => {
        items.push(type);
      });

      setOptions(items);
    }
  }, []);

  const componentsMap = {
    Presentations: Presentations,
    News: News,
    Documents: Documents,
    Webforms: Webforms,
    Events: Events,
  };

  return (
    <div className="app-main-content-wrapper">
      <div id="app-main-content">
        <div className="tabs-container">
          {options.length > 1 && (
            <FormControl className="filter-select content-select-control" size="small">
              <InputLabel className="content-select-label" size="small">
                Content Type
              </InputLabel>
              <Select
                value={activeTab}
                onChange={(e) => {
                  setContentTypeSelected(options[e.target.value].bundle);
                  setActiveTab(e.target.value);
                }}
                disabled={options.length < 1 ? true : false}
                sx={{
                  fontSize: "14px",
                }}
              >
                {options.map((option, index) => (
                  <CustomMenuItem key={`dropdown-option-${index}`} value={option.value}>
                    {option.label}
                  </CustomMenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {options.map((option, index) => {
            const Component = componentsMap[option.component];

            return (
              <div key={`component-option-${index}`} className={option.class} hidden={activeTab !== option.value}>
                {Component && <Component />}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
